// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface CoffeeCupIconSignature {
  Element: SVGSVGElement;
}

export const CoffeeCupIcon: TOC<CoffeeCupIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 6H17V5C17 4.448 16.553 4 16 4H4C3.447 4 3 4.448 3 5V13C3 14.958 3.811 16.729 5.11 18H2V20H18V18H14.89C15.964 16.95 16.696 15.557 16.92 14H18C20.205 14 22 12.206 22 10C22 7.794 20.205 6 18 6ZM15 13C15 15.757 12.757 18 10 18C7.243 18 5 15.757 5 13V6H15V13ZM17 12H18C19.104 12 20 11.103 20 10C20 8.896 19.104 8 18 8H17V12Z"/>
</svg>
</template>;